import React from 'react'
import PropTypes from 'prop-types'

const Icon = (props) => {
	const icon = props.name ? (<use xlinkHref={ `#${ props.name }` } />) : null
	return (
		<svg className={ `icon ${ props.className ? props.className : '' }` }>
			{icon}
		</svg>
	)
}
Icon.propTypes = {
	name: PropTypes.string,
	className: PropTypes.string
}
Icon.defaultProps = {
	name: '',
	className: ''
}
Icon.displayName = 'icon'

export default Icon



// WEBPACK FOOTER //
// ./src/client/webapp/components/Icons/Icon.js